<cl-sub-toolbar>
    <nav-toolbar currentTitleOverride="Device Json Viewer"></nav-toolbar>
    <div style="flex: 1 1 auto;"></div>
    <div>
        <button mat-button (click)="expandAllClicked()">
            EXPAND ALL
        </button>
    </div>
</cl-sub-toolbar>

<div class="container">
    <loading-animation *ngIf="!isReady" size="large"></loading-animation>
    <div *ngIf="isReady" class="json-viewer-wrapper">
        <ngx-json-viewer [json]="json" [depth]="depth" [expanded]="expanded"></ngx-json-viewer>
    </div>
</div>
